import { GiftCardBeneficiaryType } from '../../../../enums';
import { CardProductModel, TopUpDetailsModel } from '../../../../models/Cards';

export interface CommonCardData {
  cardSeries?: string;
  thumbnail?: string;
  products: CardProductModel[];
  selectedProduct?: CardProductModel;
  areTopUpDetailsLoading?: boolean;
  isSaveButtonLoading?: boolean;
  isPriceLoading?: boolean;
  topUpDetails?: TopUpDetailsModel;
}

export interface GenericCardData extends CommonCardData {}

export interface GiftCardData extends CommonCardData {
  showBeneficiaryTypeSelector: boolean;
  beneficiaryType?: GiftCardBeneficiaryType;
}

export enum TopUpContextType {
  TopUp,
  Buy,
}
